import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { NotificationsInboxActions } from 'applicaiton/constants/actions';
import { NotificationsAPI } from 'integration/api/notifications';
import {
  GetNotificationsParamsDto,
  UpdateNotificationParamsDto,
} from 'common/types/notifications';

/**
 * Fetch notifications data based on provided parameters.
 *
 * @param params - An object containing the query parameters for fetching notifications.
 * @returns The fetched notifications data in case of success, or an error message in case of failure.
 */
export const getNotifications = createAsyncThunk(
  NotificationsInboxActions.getNotifications,
  async (params: GetNotificationsParamsDto, { rejectWithValue }) => {
    try {
      const { data } = await NotificationsAPI.getNotifications(params);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);

/**
 * Update a notification based on provided parameters.
 *
 * @param params - An object containing the parameters for updating a specific notification.
 * @returns The updated notification data in case of success, or an error message in case of failure.
 */
export const updateNotification = createAsyncThunk(
  NotificationsInboxActions.updateNotification,
  async (params: UpdateNotificationParamsDto, { rejectWithValue }) => {
    try {
      const { data } = await NotificationsAPI.updateNotification(params);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);

/**
 * Mark all notifications as read.
 *
 * @returns The response data in case of success, or an error message in case of failure.
 */
export const readAllNotification = createAsyncThunk(
  NotificationsInboxActions.readAllNotification,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await NotificationsAPI.readAllNotification();
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
